import type { Ref } from 'vue';

import { watch } from 'vue';

export interface Props {
  modelValue: unknown;
}

export default function useField(
  props: Props,
  fieldValue: Ref<unknown>,
  emitCb: (newFieldValue: unknown) => void,
): void {
  watch(
    () => props.modelValue,
    (newModelValue) => {
      fieldValue.value = newModelValue;
    },
  );

  watch(fieldValue, (newFieldValue) => {
    emitCb(newFieldValue);
  });
}
